import React, { Component } from 'react';
import styles from './Area.module.css';
import gearWhite from '../images/gear-white.svg';
import gearBlue from '../images/gear-blue.svg';
import insertIcon from '../images/plus.svg';
import widgetDefinitions from './widgets';
import deleteIcon from '../images/cross.svg';
import Widget from './Widget';
import Dialog from './Dialog';
import { Button } from 'reactstrap';
import FormField from './FormField';

class Area extends Component {
  state = {
    dialogVisible: false
  };

  onInsertLayout = name => {
    let config = {
      ...this.props.config
    };
    var split = { areaSizes: ['auto', 'auto'], areas: [{}, config], direction: 'column', widget: 'SplitLayout' };

    this.props.onChange(split, this.props.index);
};

onDeleteWidget = name => {
  if (window.confirm("are you sure that you want to delete this?"))
  {
  let config = {
    ...this.props.config
  };
  
 config={};
  this.props.onChange(config, this.props.index);

}
};


  onFormChange = (name, value) => {
    let config = {
      ...this.props.config,
      [name]: value
    };
    if (name === 'widget') {
      if (value === 'SplitLayout') {
        config.areas = [this.props.config];
        config.direction = 'column';
        config.areaSizes = ['200px', '1'];
      } else if (value === 'Tab') {
        config.tabs = ['Tab 1', 'Tab 2'];
        config.areas = [this.props.config];
      } else {
        let moveConfig = config.areas && config.areas.find(area => area && area.widget === value);
        if (moveConfig) config = moveConfig;
      }
    }
    this.props.onChange(config, this.props.index);
  };

  onChildChange = (config, index) => {
    let newConfig = {
      ...this.props.config
    };
    newConfig.areas[index] = config;
    this.props.onChange(newConfig, this.props.index);
  };

  onDialogOkClick = () => {
    this.setState({ dialogVisible: false });
    this.props.save();
  };

  renderWidget(config, widgetDefinition) {
    if (!config.widget) {
      if (this.props.mode === 'edit') return <div>Selecteer een widget.</div>;
      return;
    }

    return (
      <Widget
        repoURL={this.props.repoURL}
        mode={this.props.mode}
        save={this.props.save}
        withinSelectedTab={this.props.withinSelectedTab}
        {...config}
        definition={widgetDefinition}
        onChange={this.onChildChange}>
        <widgetDefinition.component />
      </Widget>
    );
  }

  render() {
    let config = this.props.config || {};
    let mode = this.props.mode;
    let widgetDefinition = widgetDefinitions.find(widgetDefinition => widgetDefinition.name === config.widget);
    return (
      <div
        className={
          styles.outerAreaContainer + ' ' + (mode === 'edit' ? '' : styles.viewMode) + ' ' + styles[config.widget]
        }>
        <div className={styles.editArea}>
          <div style={{ fontSize: '0.8em', opacity: '0.5' }}>
            {config.widget && config.widget !== 'SplitLayout' && config.widget + ' widget'}
          </div>
          <div>
          

            <img
              src={insertIcon}
              alt="box"
              className={styles.insertIcon}
              onClick={() => this.onInsertLayout(config.widget)}
            />
            <img
              src={config.widget === 'SplitLayout' ? gearBlue : gearWhite}
              alt="gear"
              className={styles.editIcon}
              onClick={() => this.setState({ dialogVisible: true })}
            />
            <img
              src={deleteIcon}
              alt="cross"
              className={styles.insertIcon}
              onClick={() => this.onDeleteWidget(config.widget)}
            />
          </div>
          {this.state.dialogVisible && (
            <Dialog>
              <FormField
                name="widget"
                label="Widget"
                type="select"
                options={[
                  { label: 'Selecteer een widget', value: '' },
                  ...widgetDefinitions.map(wd => ({ label: wd.label, value: wd.name }))
                ]}
                value={config.widget}
                onChange={this.onFormChange}
              />
              {config.widget &&
                widgetDefinition.variables &&
                widgetDefinition.variables.map(variable => (
                  <FormField
                    key={variable.name}
                    {...variable}
                    value={config[variable.name]}
                    onChange={this.onFormChange}
                  />
                ))}
              <div style={{ textAlign: 'center' }}>
                <Button color="primary" style={{ minWidth: '120px', marginTop: '12px' }} onClick={this.onDialogOkClick}>
                  OK
                </Button>
              </div>
            </Dialog>
          )}
        </div>
        {this.renderWidget(config, widgetDefinition)}
      </div>
    );
  }
}

export default Area;
